import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import app from './App';
import './styles/bui-theme.css';

ReactDOM.createRoot(document.getElementById('root')!).render(app);
